'use strict';

import template from './no_profile_photo_modal.html';

export default {
  bindings: {
    done: '&',
  },
  template: template,
  controller: function($state) {
    'ngInject';

    this.addPhoto = function() {
      $state.go('settings', { noPhoto: true });
      this.done();
    };
  },
};



// WEBPACK FOOTER //
// ./app/src/components/no_profile_photo_modal/no_profile_photo_modal.js